import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import {
  productShape,
  type Product,
} from '../../../../utils/api/types/access-api-types';

export async function getProductByProductCodeApi(
  productCode = ''
): Promise<Product> {
  const product = await fetcher<Product>(`/products/code/${productCode}`, {
    service: '/fulfillment',
    version: '/v2',
  });

  return productShape.parse(product);
}

export const getProductByProductCodeApiQueryKey = (productCode = '') =>
  ['/v2', 'fulfillment', 'products', 'code', productCode].filter(Boolean);

export function useGetProductByProductCodeApi(
  productCode?: string,
  customQueryOptions?: Omit<
    UseQueryOptions<Product, ApiError<{ code: string; message: string }>>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<Product, ApiError<{ code: string; message: string }>> {
  return useQuery({
    queryKey: getProductByProductCodeApiQueryKey(productCode),
    queryFn: () => getProductByProductCodeApi(productCode),
    enabled: Boolean(productCode),
    ...customQueryOptions,
  });
}
